"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.swc = void 0;
exports.swc = {
    blue: "#2958FF",
};
//# sourceMappingURL=swc.js.map